import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ComponentService {
  private API_URL = environment.API_URL;
  constructor(private http: HttpClient) {}
  public getAllDropDownDetails(qParam: any): Observable<any> {
    return this.http.post(`${this.API_URL}/sales/realization/dropdown`, qParam);
  }
  public getNrpDropDownDetails(qParam: any, url): Observable<any> {
    return this.http.post(`${this.API_URL + url}`, qParam);
  }
  public getSalesByRegion(qParam: any, url): Observable<any> {
    return this.http.post(`${this.API_URL + url}`, qParam);
  }
  public getSalesRealization(qParam: any, url): Observable<any> {
    return this.http.post(`${this.API_URL + url}`, qParam);
  }
  public getAlgorithm(qParam: any, url): Observable<any> {
    return this.http.post(`${this.API_URL + url}`, qParam);
  }
  public getMarginRealization(qParam: any, url): Observable<any> {
    return this.http.post(`${this.API_URL + url}`, qParam);
  }
  public getDailySales(qParam: any, url): Observable<any> {
    return this.http.post(`${this.API_URL + url}`, qParam);
    // return this.http.get(`../../../assets/mock.json`);
  }
  public getTop5(qParam: any, url): Observable<any> {
    return this.http.post(`${this.API_URL + url}`, qParam);
  }
  public getSalesBridgeData(params, url): Observable<any> {
    return this.http.post(`${this.API_URL + url}`, params);
  }
  public getSalesBridgePercentage(params, url): Observable<any> {
    return this.http.post(`${this.API_URL + url}`, params);
  }
  public getPPI_diamension(params, url): Observable<any> {
    return this.http.post(`${this.API_URL + url}`, params);
  }
  public getTotalPrice(params, url): Observable<any> {
    return this.http.post(`${this.API_URL + url}`, params);
  }
  public getPurePriceImpact(params, url): Observable<any> {
    return this.http.post(`${this.API_URL + url}`, params);
  }
  public gettable(): Observable<any> {
    return this.http.get(`../../../assets/mock.json`);
  }
  public getCharts(params): Observable<any> {
    return this.http.post(
      `${this.API_URL}/sales/realization/productmix`,
      params
    );
  }
  public getsalesCharts(params, url): Observable<any> {
    return this.http.post(`${this.API_URL + url}`, params);
  }
  public getToporBottom(params, url): Observable<any> {
    return this.http.post(`${this.API_URL + '/nrp/' + url}`, params);
  }

  public getPurePriceAdjustments(params, url): Observable<any> {
    return this.http.post(`${this.API_URL + url}`, params);
  }
}
